import React from "react";
export const getSectionsByFilter = async (collection_slug) => {
  try {
    let url = `/api/v1/collections/${collection_slug}?limit=15`;
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();
    return data.items;
  } catch (error) {
    console.error(`Error in getSectionsByFilter`, error.message);
  }
};

export const getLatestMagazine = async () => {
  try {
    let url = `/api/v1/story-collections/content?tag=monthly&sort-by=collection-date&limit=1`;
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.error(`Error while fetching data for latest magazine`, error.message);
  }
};

export const getSectionsByFilterwithItems = async (collection_slug) => {
  try {
    let url = `/api/v1/collections/${collection_slug}?limit=15`;
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.error(`Error in getSectionsByFilter`, error.message);
  }
};

// const hasSubscription = async (email) => {
//   try {
//     let url = `https://subsapi.swarajyamag.com/api/subscriptions?email=${encodeURIComponent(email)}`;
//     const res = await fetch(url);
//     const data = await res.json();
//     if (data.data === null || data.error || data.status === 404) {
//       throw new Error(`Could not get the active subscription for email --> ${email}: ${data.message || "Forbidden"}`);
//     }
//     return data.subscriptions.length === 0 ? false : data.subscriptions[0].active;
//   } catch (e) {
//     console.error(e.message);
//     return false;
//   }
// };

// export const isSubscribed = async (dispatch, email) => {
//   console.log("email", email, "dispatch", dispatch);
//   try {
//     const active = await hasSubscription(email);
//     dispatch({ type: "USER_SUBSCRIBED", UserSubscribed: active });
//   } catch (e) {
//     console.error(e.message);
//     dispatch({ type: "USER_SUBSCRIBED", UserSubscribed: null });
//   }
// };
